import { render } from "./BlogSearchPage.vue?vue&type=template&id=1c8228b1&scoped=true"
import script from "./BlogSearchPage.vue?vue&type=script&lang=js"
export * from "./BlogSearchPage.vue?vue&type=script&lang=js"

import "./BlogSearchPage.vue?vue&type=style&index=0&id=1c8228b1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1c8228b1"

export default script